import Installation from './InstallationStep';

export default Installation;
